// © Microsoft Corporation. All rights reserved.

import { ActionMap } from "@msnews/experiences-redux";
import { CardSizes } from "@msnews/card-properties";

export type ChangeCardSizeSignature = (virtualCardSize: CardSizes, width: number, height: number) => void;

/**
 * Exposes the actions to update state on river child components
 * @class
 */
export class RiverCardActions {

    /**
     * Action for changing the size of the rendered card when rendering an experience in a river section
     */
    public static changeCardSize: ActionMap<ChangeCardSizeSignature> = new ActionMap<ChangeCardSizeSignature>("ChangeCardSize");
}